import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import ConfirmModal from './ConfirmModal';

// ── Bulk Stock ──────────────────────────────────────────────
export function BulkStock() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get('/api/bulk-stock').then(r => setItems(r.data)).catch(()=>{}); }, []);
  return (
    <div>
      <div className="sh">สต็อก Bulk (ผสมแล้ว รอบรรจุ)</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>Batch</th><th>กลิ่น</th><th>kg คงเหลือ</th>{user?.can_see_cost&&<th>ต้นทุน/kg</th>}<th>วันที่ผสม</th></tr></thead>
          <tbody>
            {items.map(b => (
              <tr key={b.id}>
                <td style={{ fontFamily:'monospace',fontSize:11,color:'var(--text-muted)' }}>{b.batch_no}</td>
                <td style={{ fontWeight:600,color:'var(--text-primary)' }}>{b.formula_name}</td>
                <td style={{ fontWeight:600 }}>{parseFloat(b.qty_kg).toFixed(4)}</td>
                {user?.can_see_cost&&<td>฿{parseFloat(b.cost_per_kg||0).toFixed(2)}</td>}
                <td>{new Date(b.created_at).toLocaleDateString('th-TH')}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan="5" style={{ textAlign:'center',color:'var(--text-muted)',padding:20 }}>ไม่มีสต็อก Bulk</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Finished Stock ──────────────────────────────────────────
export function FinishedStock() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get('/api/finished-stock').then(r => setItems(r.data)).catch(()=>{}); }, []);
  return (
    <div>
      <div className="sh">สต็อก Finished (บรรจุขวดแล้ว)</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>กลิ่น</th><th>ขวด</th><th>ขนาด</th><th>คงเหลือ</th>{user?.can_see_cost&&<th>ต้นทุน/ขวด</th>}<th>วันที่อัปเดต</th></tr></thead>
          <tbody>
            {items.map(f => (
              <tr key={f.id}>
                <td style={{ fontWeight:600,color:'var(--text-primary)' }}>{f.formula_name}</td>
                <td>{f.bottle_name}</td>
                <td>{f.bottle_size_ml} ml</td>
                <td style={{ fontWeight:600 }}>{f.qty_bottles} ขวด</td>
                {user?.can_see_cost&&<td>฿{parseFloat(f.cost_per_bottle||0).toFixed(2)}</td>}
                <td style={{ color:'var(--text-muted)',whiteSpace:'nowrap' }}>{new Date(f.updated_at).toLocaleDateString('th-TH')}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan="6" style={{ textAlign:'center',color:'var(--text-muted)',padding:20 }}>ไม่มีสต็อก Finished</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Stock Adjustment ────────────────────────────────────────
export function Adjust() {
  const [materials, setMaterials] = useState([]);
  const [bulkStocks, setBulkStocks] = useState([]);
  const [finishedStocks, setFinishedStocks] = useState([]);
  const [form, setForm] = useState({ stock_type:'raw', material_id:'', bulk_stock_id:'', finished_stock_id:'', adj_type:'increase', qty:'', reason:'', notes:'' });
  const [confirm, setConfirm] = useState(false);
  const [msg, setMsg] = useState({ text:'', ok:true });
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axios.get('/api/materials').then(r => setMaterials(r.data));
    axios.get('/api/bulk-stock').then(r => setBulkStocks(r.data)).catch(()=>{});
    axios.get('/api/finished-stock').then(r => setFinishedStocks(r.data)).catch(()=>{});
    axios.get('/api/adjustments').then(r => setHistory(r.data));
  }, []);

  const setF = (k,v) => setForm(f=>({...f,[k]:v}));
  const showMsg = (text, ok=true) => { setMsg({text,ok}); setTimeout(()=>setMsg({text:'',ok:true}),3000); };

  const handleSubmit = async () => {
    try {
      await axios.post('/api/adjustments', form);
      showMsg('ปรับสต็อกสำเร็จ');
      setForm({ stock_type:'raw', material_id:'', bulk_stock_id:'', finished_stock_id:'', adj_type:'increase', qty:'', reason:'', notes:'' });
      axios.get('/api/adjustments').then(r => setHistory(r.data));
    } catch (err) {
      showMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด', false);
    }
    setConfirm(false);
  };

  return (
    <div>
      {confirm && <ConfirmModal title="ยืนยันปรับสต็อก" body={`${form.adj_type==='increase'?'เพิ่ม':'ลด'} ${form.qty} · เหตุผล: ${form.reason}`} onConfirm={handleSubmit} onCancel={() => setConfirm(false)}/>}
      {msg.text && <div className={`alert ${msg.ok?'alert-success':'alert-danger'}`}>{msg.text}</div>}

      <div className="sh">ปรับสต็อก</div>
      <div className="glass-card">
        <div className="grid-2">
          <div className="form-group"><label className="fl">ประเภทสต็อก</label>
            <select className="fi" value={form.stock_type} onChange={e => setF('stock_type',e.target.value)}>
              <option value="raw">Raw Material</option>
              <option value="bulk">Bulk Stock</option>
              <option value="finished">Finished Stock</option>
            </select>
          </div>
          <div className="form-group"><label className="fl">เพิ่ม / ลด</label>
            <select className="fi" value={form.adj_type} onChange={e => setF('adj_type',e.target.value)}>
              <option value="increase">เพิ่ม (+)</option>
              <option value="decrease">ลด (−)</option>
            </select>
          </div>
          {form.stock_type==='raw' && <div className="form-group"><label className="fl">วัตถุดิบ</label>
            <select className="fi" value={form.material_id} onChange={e => setF('material_id',e.target.value)}>
              <option value="">เลือกวัตถุดิบ</option>
              {materials.map(m=><option key={m.id} value={m.id}>{m.name} ({parseFloat(m.stock_qty).toFixed(2)} {m.unit})</option>)}
            </select>
          </div>}
          {form.stock_type==='bulk' && <div className="form-group"><label className="fl">Bulk Batch</label>
            <select className="fi" value={form.bulk_stock_id} onChange={e => setF('bulk_stock_id',e.target.value)}>
              <option value="">เลือก batch</option>
              {bulkStocks.map(b=><option key={b.id} value={b.id}>{b.batch_no} · {b.formula_name}</option>)}
            </select>
          </div>}
          {form.stock_type==='finished' && <div className="form-group"><label className="fl">สินค้าสำเร็จรูป</label>
            <select className="fi" value={form.finished_stock_id} onChange={e => setF('finished_stock_id',e.target.value)}>
              <option value="">เลือกสินค้า</option>
              {finishedStocks.map(f=><option key={f.id} value={f.id}>{f.formula_name} {f.bottle_size_ml}ml</option>)}
            </select>
          </div>}
          <div className="form-group"><label className="fl">จำนวน</label><input className="fi" type="number" value={form.qty} onChange={e => setF('qty',e.target.value)}/></div>
          <div className="form-group"><label className="fl">เหตุผล (บังคับ)</label><input className="fi" value={form.reason} onChange={e => setF('reason',e.target.value)} placeholder="นับผิด, ของหาย..."/></div>
        </div>
        <div className="btn-row">
          <button className="btn-primary" disabled={!form.qty||!form.reason} onClick={() => setConfirm(true)}>ยืนยันปรับสต็อก</button>
        </div>
      </div>

      <div className="sh">ประวัติการปรับสต็อก</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>วันที่</th><th>ประเภท</th><th>รายการ</th><th>การปรับ</th><th>จำนวน</th><th>เหตุผล</th><th>โดย</th></tr></thead>
          <tbody>
            {history.map(h => (
              <tr key={h.id}>
                <td>{new Date(h.created_at).toLocaleDateString('th-TH')}</td>
                <td><span className="badge badge-blue">{h.stock_type}</span></td>
                <td>{h.material_name||'—'}</td>
                <td><span className={`badge ${h.adj_type==='increase'?'badge-ok':'badge-err'}`}>{h.adj_type==='increase'?'เพิ่ม':'ลด'}</span></td>
                <td style={{ fontWeight:600 }}>{parseFloat(h.qty).toFixed(4)}</td>
                <td>{h.reason}</td>
                <td>{h.created_by_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Audit Trail ─────────────────────────────────────────────
export function Audit() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [filterUser, setFilterUser] = useState('');
  const [filterDate, setFilterDate] = useState('');

  useEffect(() => {
    axios.get('/api/users').then(r => setUsers(r.data));
    load();
  }, []);

  const load = (uid, date) => {
    let url = '/api/audit?';
    if (uid) url += `user_id=${uid}&`;
    if (date) url += `date=${date}`;
    axios.get(url).then(r => setLogs(r.data));
  };

  return (
    <div>
      <div className="sh">Audit Trail — ประวัติการทำงาน</div>
      <div className="glass-card">
        <div className="grid-2" style={{ marginBottom:12 }}>
          <div className="form-group"><label className="fl">User</label>
            <select className="fi" value={filterUser} onChange={e => setFilterUser(e.target.value)}>
              <option value="">ทุก user</option>
              {users.map(u=><option key={u.id} value={u.id}>{u.username} · {u.name}</option>)}
            </select>
          </div>
          <div className="form-group"><label className="fl">วันที่</label>
            <input className="fi" type="date" value={filterDate} onChange={e => setFilterDate(e.target.value)}/>
          </div>
        </div>
        <div className="btn-row" style={{ marginBottom:12 }}>
          <button className="btn-primary" onClick={() => load(filterUser, filterDate)}>ค้นหา</button>
        </div>
        <table className="tbl">
          <thead><tr><th>เวลา</th><th>User</th><th>Action</th><th>รายละเอียด</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id}>
                <td style={{ whiteSpace:'nowrap' }}>{new Date(l.created_at).toLocaleString('th-TH')}</td>
                <td>{l.username}</td>
                <td><span className="badge badge-blue">{l.action}</span></td>
                <td style={{ fontSize:11,maxWidth:280,overflow:'hidden',textOverflow:'ellipsis' }}>{l.detail}</td>
              </tr>
            ))}
            {!logs.length && <tr><td colSpan="4" style={{ textAlign:'center',color:'var(--text-muted)',padding:20 }}>ไม่พบข้อมูล</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Initial Setup ───────────────────────────────────────────
export function Setup() {
  const [materials, setMaterials] = useState([]);
  const [formulas, setFormulas] = useState([]);
  const [bottles, setBottles] = useState([]);
  const [rawRows, setRawRows] = useState([{ material_id:'', qty:'', avg_cost:'' }]);
  const [finRows, setFinRows] = useState([{ formula_id:'', bottle_material_id:'', bottle_size_ml:'30', qty_bottles:'', cost_per_bottle:'' }]);
  const [msg, setMsg] = useState('');
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
    axios.get('/api/materials').then(r => {
      setMaterials(r.data.filter(m=>m.category==='raw_material'));
      setBottles(r.data.filter(m=>m.category==='packaging'));
    });
    axios.get('/api/formulas').then(r => setFormulas(r.data)).catch(()=>{});
  }, []);

  const addRaw = () => setRawRows(r=>[...r,{material_id:'',qty:'',avg_cost:''}]);
  const updRaw = (i,k,v) => setRawRows(r=>r.map((row,idx)=>idx===i?{...row,[k]:v}:row));
  const addFin = () => setFinRows(r=>[...r,{formula_id:'',bottle_material_id:'',bottle_size_ml:'30',qty_bottles:'',cost_per_bottle:''}]);
  const updFin = (i,k,v) => setFinRows(r=>r.map((row,idx)=>idx===i?{...row,[k]:v}:row));

  const handleSubmit = async () => {
    try {
      await axios.post('/api/setup', {
        raw_materials: rawRows.filter(r=>r.material_id&&r.qty),
        finished_items: finRows.filter(r=>r.formula_id&&r.bottle_material_id&&r.qty_bottles)
      });
      setMsg('บันทึกค่าตั้งต้นสำเร็จ');
      setTimeout(() => setMsg(''), 4000);
    } catch (err) {
      setMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด');
    }
    setConfirm(false);
  };

  return (
    <div>
      {confirm && <ConfirmModal title="ยืนยันบันทึกค่าตั้งต้น" body="การบันทึกจะ override สต็อกปัจจุบัน ยืนยันใช่ไหม?" onConfirm={handleSubmit} onCancel={() => setConfirm(false)} danger/>}
      <div className="alert alert-warn"><i className="ti ti-alert-triangle"/> ใช้เฉพาะตอนเริ่มต้นใช้ระบบครั้งแรก — superadmin เท่านั้น</div>
      {msg && <div className={`alert ${msg.includes('สำเร็จ')?'alert-success':'alert-danger'}`}>{msg}</div>}

      <div className="sh">สต็อกเริ่มต้น — วัตถุดิบ</div>
      <div className="glass-card">
        <div style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr auto',gap:6,marginBottom:6 }}>
          <div className="fl">วัตถุดิบ</div><div className="fl">จำนวน</div><div className="fl">avg cost/หน่วย</div><div/>
        </div>
        {rawRows.map((row,i) => (
          <div key={i} style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr auto',gap:6,marginBottom:6,alignItems:'center' }}>
            <select className="fi" value={row.material_id} onChange={e => updRaw(i,'material_id',e.target.value)}>
              <option value="">เลือกวัตถุดิบ</option>
              {materials.map(m=><option key={m.id} value={m.id}>{m.name} ({m.unit})</option>)}
            </select>
            <input className="fi" type="number" placeholder="qty" value={row.qty} onChange={e => updRaw(i,'qty',e.target.value)}/>
            <input className="fi" type="number" placeholder="฿/หน่วย" value={row.avg_cost} onChange={e => updRaw(i,'avg_cost',e.target.value)}/>
            <button className="btn-secondary" style={{ padding:'7px 10px' }} onClick={() => setRawRows(r=>r.filter((_,idx)=>idx!==i))}>✕</button>
          </div>
        ))}
        <button className="btn-secondary" style={{ fontSize:11,padding:'5px 12px' }} onClick={addRaw}>+ เพิ่มแถว</button>
      </div>

      <div className="sh">สต็อกเริ่มต้น — สินค้าสำเร็จรูป</div>
      <div className="glass-card">
        <div style={{ display:'grid',gridTemplateColumns:'2fr 1.5fr 80px 80px 100px auto',gap:6,marginBottom:6 }}>
          <div className="fl">กลิ่น</div><div className="fl">ขวด</div><div className="fl">ขนาด</div><div className="fl">จำนวน</div><div className="fl">ต้นทุน/ขวด</div><div/>
        </div>
        {finRows.map((row,i) => (
          <div key={i} style={{ display:'grid',gridTemplateColumns:'2fr 1.5fr 80px 80px 100px auto',gap:6,marginBottom:6,alignItems:'center' }}>
            <select className="fi" value={row.formula_id} onChange={e => updFin(i,'formula_id',e.target.value)}>
              <option value="">เลือกกลิ่น</option>
              {formulas.map(f=><option key={f.id} value={f.id}>{f.name}</option>)}
            </select>
            <select className="fi" value={row.bottle_material_id} onChange={e => updFin(i,'bottle_material_id',e.target.value)}>
              <option value="">เลือกขวด</option>
              {bottles.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
            <input className="fi" type="number" value={row.bottle_size_ml} onChange={e => updFin(i,'bottle_size_ml',e.target.value)}/>
            <input className="fi" type="number" placeholder="ขวด" value={row.qty_bottles} onChange={e => updFin(i,'qty_bottles',e.target.value)}/>
            <input className="fi" type="number" placeholder="฿" value={row.cost_per_bottle} onChange={e => updFin(i,'cost_per_bottle',e.target.value)}/>
            <button className="btn-secondary" style={{ padding:'7px 10px' }} onClick={() => setFinRows(r=>r.filter((_,idx)=>idx!==i))}>✕</button>
          </div>
        ))}
        <button className="btn-secondary" style={{ fontSize:11,padding:'5px 12px' }} onClick={addFin}>+ เพิ่มแถว</button>
      </div>

      <div className="btn-row">
        <button className="btn-primary" onClick={() => setConfirm(true)}>บันทึกค่าตั้งต้น</button>
      </div>
    </div>
  );
}
